import { Link } from "react-router";
import { TestIdClassNameProps } from "@app/types/Common";
import thumbnail from "@assets/budget2024-infographics-thumbnail.png";
import { BlockTitle } from "@blocks/Blocks";
import { BUDGET2024_INFOGRAPHICS_LINK } from "@routes/SingaporeBudget/2024/constants";

export type InfographicsProps = TestIdClassNameProps;

export default function Infographics({
  testId,
  rootClassName,
}: InfographicsProps): React.ReactElement {
  return (
    <div className={rootClassName} data-testid={testId}>
      <BlockTitle text="INFOGRAPHICS" rootClassName="mb-4" />

      <div className="group relative flex gap-4">
        <img
          src={thumbnail}
          width={100}
          height={67}
          alt="Singapore Budget 2024"
          className="aspect-3x2 object-contain"
        />

        <h2 className="font-lct text-base font-bold group-hover:underline lg:text-lg">
          Key Budget Numbers
        </h2>

        <Link
          to={BUDGET2024_INFOGRAPHICS_LINK}
          target="_blank"
          className="absolute inset-0"
        />
      </div>
    </div>
  );
}
